import { useContext } from "react"
import { UserContext } from "../../../context/userContext"

//primeReact
import { Card } from "primereact/card"
import { Tooltip } from "primereact/tooltip"
import { ScrollPanel } from "primereact/scrollpanel"

//styles
import docSignStyles from "../../../styles/documentSigning/DocSign.templates.module.css"
import { Button } from "primereact/button"

export default function TemplateViewCard({
  template,
  deletingTemplateIds,
  stripMetaKey,
  onEditTemplate,
  onEditOrganizations,
  onShowTemplate,
  onDeleteTemplate,
  organizations,
}) {
  const userCtx = useContext(UserContext)

  const templateGroupId = stripMetaKey(template.metadata["GroupId"])
  const hasAnotherSourceGroup =
    templateGroupId !== userCtx.session.user.organization_id

  function cardHeader() {
    return (
      <div className={docSignStyles.cardTitle}>
        {template.title || "[No Title]"}
      </div>
    )
  }

  function getOrganizationName(organization_id) {
    let organizationName = `<Unknown: ${organization_id}>`

    if (!!organizations) {
      let organization = organizations.filter(
        (org) =>
          org.organization_id === organization_id ||
          org.organization_alias === organization_id
      )
      if (organization.length > 0) {
        organizationName = organization[0].organization_name
      }
    }

    return organizationName
  }

  return (
    <Card header={cardHeader} className={docSignStyles.card}>
      <div className={docSignStyles.templateLayout}>
        <div className={docSignStyles.templateLayoutHeader}>
          <b>Created: </b>
        </div>
        <div className={docSignStyles.templateLayoutBy}>
          {" "}
          {"By: "}
          {template?.templateCreatedBy}
        </div>
        <div className={docSignStyles.templateLayoutAt}>
          {" "}
          {"At: "}
          {template?.templateCreatedOn.toLocaleString()}
        </div>
        <div className={docSignStyles.templateLayoutOrganizations}>
          {template?.additionalOrganizations?.length > 0 &&
          templateGroupId === userCtx.session.user.organization_id ? (
            <>
              <b>Organizations</b>
              <div
                style={{
                  marginLeft: 10,
                  marginRight: 5,
                }}
              >
                <ScrollPanel className={docSignStyles.cardScrollPanel}>
                  {template?.additionalOrganizations.map((org, index) => {
                    return (
                      <span key={index}>
                        {getOrganizationName(org)}{" "}
                        {index < template.additionalOrganizations.length - 1 ? (
                          <br />
                        ) : null}
                      </span>
                    )
                  })}
                </ScrollPanel>
                {templateGroupId !== userCtx.session.user.organization_id &&
                templateGroupId !== userCtx.session.user.organization_alias ? (
                  <>
                    <b>Owner:</b>
                    <div
                      style={{
                        marginLeft: 10,
                        marginRight: 5,
                      }}
                    >
                      {getOrganizationName(templateGroupId)}
                    </div>
                  </>
                ) : null}
              </div>
            </>
          ) : null}
        </div>
        <div className={docSignStyles.templateLayoutControls}>
          <div className={docSignStyles.cardOptions}>
            {userCtx.session.user.organization_id ===
            userCtx.session.user.enterprise_id ? (
              <Button
                type="button"
                className={`btn t-tip ${docSignStyles.cardOptionButton}`}
                tooltip="Manage organization allocation"
                tooltipOptions={{ position: "bottom" }}
                onClick={(e) => {
                  onEditOrganizations()
                }}
                disabled={
                  templateGroupId !== userCtx.session.user.organization_id
                }
              >
                <span className={`material-icons`}>{"groups"}</span>
              </Button>
            ) : null}
            <Button
              type="button"
              className={`btn t-tip ${docSignStyles.cardOptionButton}`}
              tooltip="Edit template"
              tooltipOptions={{ position: "bottom" }}
              onClick={(e) => {
                onEditTemplate(template.templateId)
              }}
              disabled={hasAnotherSourceGroup || deletingTemplateIds.includes(template.templateId)}
            >
              <span className={`material-icons`}>{"edit"}</span>
            </Button>
            <Button
              type="button"
              className={`btn t-tip ${docSignStyles.cardOptionButton}`}
              style={{ padding: "5px 8px" }}
              tooltip="Additional template information"
              tooltipOptions={{ position: "bottom" }}
              onClick={(e) => {
                onShowTemplate(template)
              }}
            >
              <span className={`material-icons`}>{"info"}</span>
            </Button>
            <Button
              type="button"
              className={`btn ${docSignStyles.cardOptionButton}`}
              tooltip="Remove template"
              tooltipOptions={{ position: "bottom" }}
              onClick={(e) => {
                onDeleteTemplate(template)
              }}
              disabled={hasAnotherSourceGroup || deletingTemplateIds.includes(template.templateId)}
            >
              <span className={`material-icons`}>{"delete"}</span>
            </Button>
          </div>
        </div>
      </div>
    </Card>
  )
}
